export default "__VITE_ASSET__70eaed4d__"